import 'debug';
import { i as debounce, _ as _asyncToGenerator, h as _regeneratorRuntime } from './index2.js';
import 'deepmerge';
import 'axios';
import 'vue';
import { _ as __vue_normalize__ } from './normalize-component.js';

var location = {
  data: function data() {
    return {
      coords: null,
      coordsBoundaries: {
        topLeft: null,
        bottomRight: null,
        rotatedTopLeft: null,
        rotatedBottomRight: null
      },
      positioningEngine: null
    };
  },
  // two lines
  // for getters
  computed: {
    locationParams: function locationParams() {
      if (this.pageData.System && !isNaN(this.pageData.DiffNorth) && this.pageData.Coords.topLeft && this.pageData.Coords.bottomRight) {
        return {
          system: this.pageData.System,
          diffNorth: this.pageData.DiffNorth,
          topLeft: this.pageData.Coords.topLeft,
          bottomRight: this.pageData.Coords.bottomRight
        };
      }

      return null;
    }
  },
  methods: {
    initLocationSystem: function initLocationSystem(params) {
      var _this = this;

      this.initCoordsData(params);

      switch (params.system.toLowerCase()) {
        case 'gps':
          this.positioningEngine = this.$xp.positioning.getEngine('GPS');
          this.positioningEngine.subscribe(this.setUtmStandPointIndicator);
          this.positioningEngine.start();
          this.$once('hook:beforeDestroy', function () {
            _this.positioningEngine.stop();
          });
          break;

        case 'pseudo':
          var pseudoEngine = this.$xp.positioning.getEngine('Pseudo');
          var pseudoCoords = pseudoEngine.getLastPosition();
          pseudoCoords && this.setUtmStandPointIndicator(pseudoCoords);
          break;

        case 'wlan':
          var fraunhoferEngine = this.$xp.positioning.getEngine('FraunhoferPosition');
          fraunhoferEngine.subscribe(this.setUtmStandPointIndicator);
          break;
      }
    },
    initCoordsData: function initCoordsData(params) {
      if (params.topLeft && params.bottomRight) {
        console.log('initCoordsData(', params, ')');
        this.coordsBoundaries.topLeft = {
          easting: params.topLeft.easting,
          northing: params.topLeft.northing
        };
        this.coordsBoundaries.bottomRight = {
          easting: params.bottomRight.easting,
          northing: params.bottomRight.northing
        };
        this.coordsCenter = {
          easting: this.coordsBoundaries.topLeft.easting + (this.coordsBoundaries.bottomRight.easting - this.coordsBoundaries.topLeft.easting) / 2,
          northing: this.coordsBoundaries.topLeft.northing + (this.coordsBoundaries.bottomRight.northing - this.coordsBoundaries.topLeft.northing) / 2
        };
        this.alphaRotation = -params.diffNorth * (Math.PI / 180);
        console.log('alphaRotation:', this.alphaRotation);
        this.coordsBoundaries.rotatedTopLeft = this.rotateUTM(this.coordsBoundaries.topLeft);
        this.coordsBoundaries.rotatedBottomRight = this.rotateUTM(this.coordsBoundaries.bottomRight); // this.pixelsInMeter = this.width / (this.coordsBoundaries.bottomRight.easting - this.coordsBoundaries.topLeft.easting)

        console.log('initCoordsData(', params, ') boundries=', this.coordsBoundaries, ', center:', this.coordsCenter);
      } else {
        console.log('initCoordsData(', params, ') attributes missing');
      }
    },
    rotateUTM: function rotateUTM(utmCoords) {
      if (this.alphaRotation) {
        return Object.assign({}, utmCoords, {
          easting: this.coordsCenter.easting + Math.cos(this.alphaRotation) * (utmCoords.easting - this.coordsCenter.easting) - Math.sin(this.alphaRotation) * (utmCoords.northing - this.coordsCenter.northing),
          northing: this.coordsCenter.northing + Math.sin(this.alphaRotation) * (utmCoords.easting - this.coordsCenter.easting) + Math.cos(this.alphaRotation) * (utmCoords.northing - this.coordsCenter.northing)
        });
      } else {
        return Object.assign({}, utmCoords);
      }
    },
    getFixedAccuracy: function getFixedAccuracy(utmCoords) {
      var MIN_QUALITY_ACCURACY = 2.5; // 5m for quality = 0

      var MAX_QUALITY_ACCURACY = 10; // 15m for quality = 1

      var DEFAULT_PERCENT_ACCURACY = 0.1; // 10% of the biggest dimension

      var mapWidth = Math.abs(this.coordsBoundaries.rotatedTopLeft.easting - this.coordsBoundaries.rotatedBottomRight.easting);
      var mapHeight = Math.abs(this.coordsBoundaries.rotatedTopLeft.northing - this.coordsBoundaries.rotatedBottomRight.northing);
      var maxAccuracy = Math.min(mapHeight, mapWidth) * 0.5;
      var minAccuracy = Math.max(mapWidth, mapHeight) * 0.05;

      if (utmCoords.accuracy) {
        // if accuracy is set make sure its not bigger then the max and min accuracy
        return Math.max(minAccuracy, Math.min(utmCoords.accuracy, maxAccuracy)) * 2; // radius * 2 = width and height
      } else if (utmCoords.quality >= 0 && utmCoords.quality <= 1) {
        // if quality is between 0 and 1 then accuracy is between MIN_QUALITY_ACCURACY to MAX_QUALITY_ACCURACY and min and max accuracy
        var accuracyFromQuality = MAX_QUALITY_ACCURACY - (MAX_QUALITY_ACCURACY - MIN_QUALITY_ACCURACY) * utmCoords.quality;
        return Math.max(minAccuracy, Math.min(accuracyFromQuality, maxAccuracy)) * 2;
      } else {
        // if neither is set (PseudoLocation), accuracy is on default value
        return Math.max(mapWidth, mapHeight) * DEFAULT_PERCENT_ACCURACY;
      }
    },
    setUtmStandPointIndicator: function setUtmStandPointIndicator(utmCoords) {
      var point = this.$el.querySelector('.js-stand-point'); // console.log('setUtmStandPointIndicator()', utmCoords, this.geoData)

      if (utmCoords.easting && utmCoords.northing) {
        var fixedAccuracy = this.getFixedAccuracy(utmCoords);
        this.coords = utmCoords;
        var rotatedCoords = this.rotateUTM(utmCoords);
        var topPercentage = 100 * Math.abs(rotatedCoords.northing - this.coordsBoundaries.rotatedTopLeft.northing) / Math.abs(this.coordsBoundaries.rotatedBottomRight.northing - this.coordsBoundaries.rotatedTopLeft.northing);
        var leftPercentage = 100 * Math.abs(rotatedCoords.easting - this.coordsBoundaries.rotatedTopLeft.easting) / Math.abs(this.coordsBoundaries.rotatedBottomRight.easting - this.coordsBoundaries.rotatedTopLeft.easting);
        var accuracyWidth = Math.round(fixedAccuracy / Math.abs(this.coordsBoundaries.rotatedBottomRight.easting - this.coordsBoundaries.rotatedTopLeft.easting) * 100);
        var accuracyHeight = Math.round(fixedAccuracy / Math.abs(this.coordsBoundaries.rotatedBottomRight.northing - this.coordsBoundaries.rotatedTopLeft.northing) * 100);
        point.style.width = accuracyWidth + '%';
        point.style.height = accuracyHeight + '%';
        point.style.top = topPercentage + '%';
        point.style.left = leftPercentage + '%';
        point.style.display = 'block';
        this.$emit('stand-point-indicator-position-changed', {
          topPercentage: topPercentage,
          leftPercentage: leftPercentage
        }); // console.log('setUtmStandPointIndicator show(easting=', utmCoords.easting, ', left=', Math.round(leftPercentage), '%, northing=', utmCoords.northing, ', top=', Math.round(topPercentage), '%)')
      } else {
        point.style.display = 'none';
        console.log('setUtmStandPointIndicator hide');
      }
    }
  }
};

var tapCounter = 0;
var singleClickTimer = null;
var script = {
  name: 'PanzoomMap',
  mixins: [location],
  props: {
    width: {
      type: Number,
      required: true
    },
    height: {
      type: Number,
      required: true
    },
    startCenter: {
      type: Object,
      required: true
    },
    minZoom: {
      type: Number,
      default: 0
    },
    maxZoom: {
      type: Number,
      default: Infinity
    },
    startZoom: {
      type: Number
    },
    // allowZoom: {
    //   type: Boolean,
    //   default: true
    // },
    doubleTapZoomRatio: {
      type: Number,
      default: 1.5
    },
    inHomePage: {
      type: Boolean,
      default: false
    },
    geoData: {
      type: Object
    }
  },
  data: function data() {
    return {
      transform: {
        x: 0,
        y: 0,
        scale: 1,
        minX: 0,
        maxX: 0,
        minY: 0,
        maxY: 0,
        minScale: 1,
        maxScale: 1
      },
      mapSize: {
        width: 0,
        height: 0
      },
      wrapperSize: {
        width: 0,
        height: 0
      },
      referenceImageWidth: 1920,
      // fixedZoomRatio: null,
      scale100Percent: 0,
      locationPathAngle: 0,
      isInteracting: false,
      lastTouchData: null,
      hasMoved: false,
      isAutoScrolling: false,
      isInitialized: false,
      showHints: true
    };
  },
  computed: {
    devicePixelRatio: function devicePixelRatio() {
      return window.devicePixelRatio;
    },
    transformMatrix: function transformMatrix() {
      // console.log('transformMatrix() x=', this.transform.x, ', y=', this.transform.y, ', scale=', this.transform.scale)
      return "matrix(".concat(this.transform.scale, ", 0, 0, ").concat(this.transform.scale, ", ").concat(this.transform.x, ", ").concat(this.transform.y, ")");
    },
    allowZoom: function allowZoom() {
      if (this.maxZoom !== this.minZoom) return true;else return false;
    }
  },
  created: function created() {
    this.removeIsInteractingAfterWheel = debounce(this.removeIsInteractingAfterWheel);
  },
  mounted: function mounted() {
    this.mapElement = this.$el.querySelector('.js-map');
    this.wrapperSize = this.getWrapperSize();

    if (this.wrapperSize.width > 0) {
      this.init();
    }

    this.$on('stand-point-indicator-position-changed', this.onStandPointIndicatorPositionChanged); // else: wait for call to reInit()
    // console.log('devicePixelRatio', window.devicePixelRatio)
  },
  beforeDestroy: function beforeDestroy() {
    this.$off('stand-point-indicator-position-changed', this.onStandPointIndicatorPositionChanged);
  },
  methods: {
    isStandPointIndicatorInViewport: function isStandPointIndicatorInViewport() {
      var point = this.$el.querySelector('.js-stand-point span');

      if (!point) {
        return false;
      }

      var bounding = point.getBoundingClientRect();
      return bounding.top >= 0 && bounding.left >= 0 && bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) && bounding.right <= (window.innerWidth || document.documentElement.clientWidth);
    },
    getWrapperSize: function getWrapperSize() {
      return this.mapElement.parentElement.getBoundingClientRect();
    },
    init: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this = this;

        var transform, pseudoCoords, x, y;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.pageId = this.$route.params.id; // this.fixedZoomRatio = this.$xp.settings.mergedSettings.zoomRatio

                this.mapSize.width = this.width / devicePixelRatio;
                this.mapSize.height = this.height / devicePixelRatio; // console.log(`this.wrapperSize = (${this.wrapperSize.width}, ${this.wrapperSize.height})`)
                // console.log(`this.mapSize = (${this.mapSize.width}, ${this.mapSize.height})`)

                this.transform.minScale = Math.min(this.wrapperSize.width / this.mapSize.width, this.wrapperSize.height / this.mapSize.height);
                this.transform.maxScale = this.referenceImageWidth / this.wrapperSize.width;
                this.scale100Percent = this.wrapperSize.width * devicePixelRatio / this.referenceImageWidth;

                if (this.maxZoom < Infinity) {
                  this.transform.maxScale = this.scale100Percent * this.maxZoom / 100;
                }

                if (this.minZoom > 0) {
                  this.transform.minScale = this.scale100Percent * this.minZoom / 100;
                } // set center


                if (!this.$xp.history.historyParams['transform']) {
                  _context.next = 16;
                  break;
                }

                transform = Object.assign({}, this.$xp.history.historyParams['transform']);
                this.setScale(transform.scale);
                _context.next = 13;
                return this.$nextTick();

              case 13:
                this.setTransform(transform.x, transform.y);
                _context.next = 20;
                break;

              case 16:
                this.startZoom ? this.setScale(this.startZoom / 100 * this.scale100Percent) : this.setScale(this.scale100Percent);
                _context.next = 19;
                return this.$nextTick();

              case 19:
                if (this.startCenter.x !== null && this.startCenter.y != null && (Math.abs(this.startCenter.x) > 0 || Math.abs(this.startCenter.y) > 0)) {
                  // console.log('startCenter set', this.startCenter)
                  this.setCenter(this.startCenter.x, this.startCenter.y);
                } else {
                  this.setCenter(0, 0); // this.setTransform(this.transform.x, this.transform.y)
                }

              case 20:
                if (this.geoData) {
                  this.initLocationSystem(this.geoData); // set center on pseudo location

                  pseudoCoords = this.getPseudoCoords();

                  if (pseudoCoords) {
                    console.log(pseudoCoords);
                    x = this.width * (Math.abs(pseudoCoords.easting - this.geoData.topLeft.easting) / Math.abs(this.geoData.bottomRight.easting - this.geoData.topLeft.easting));
                    y = this.height * (Math.abs(pseudoCoords.northing - this.geoData.topLeft.northing) / Math.abs(this.geoData.bottomRight.northing - this.geoData.topLeft.northing));
                    setTimeout(function () {
                      _this.setCenter(x, y);
                    }, 300);
                  }
                  /*
                  let corners = [
                    this.geoData.topLeft,
                    this.geoData.bottomRight,
                    // { easting: 107, northing: 84, accuracy: 5, zone: 32, hemisphere: 'N' }
                    { easting: 87, northing: 16, accuracy: 5, zone: 32, hemisphere: 'N' }
                  ]
                   this.showLocationPathCorners(corners)
                  setInterval(() => { this.showLocationPathCorners(corners) }, 30000)
                  */
                  // setInterval(() => { this.showLocationPathCircle(this.coordsCenter, (this.coordsBoundries.rotatedBottomRight.northing - this.coordsBoundries.rotatedTopLeft.northing) / 3) }, 300)
                  // console.log('coordsBoundries:', this.coordsBoundries)
                  // console.log('geo width:', Math.abs(this.coordsBoundries.rotatedBottomRight.easting - this.coordsBoundries.rotatedTopLeft.easting))
                  // console.log('geo height:', Math.abs(this.coordsBoundries.rotatedBottomRight.northing - this.coordsBoundries.rotatedTopLeft.northing))
                  // console.log('geo rotated width:', Math.abs(this.coordsBoundries.bottomRight.easting - this.coordsBoundries.topLeft.easting))
                  // console.log('geo rotated height:', Math.abs(this.coordsBoundries.bottomRight.northing - this.coordsBoundries.topLeft.northing))

                }

                this.lastTouchData = this.touchData = {};
                _context.next = 24;
                return this.$nextTick();

              case 24:
                setTimeout(function () {
                  _this.isInitialized = true;
                }, 300);

              case 25:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }(),
    onStandPointIndicatorPositionChanged: function onStandPointIndicatorPositionChanged(_ref) {
      var topPercentage = _ref.topPercentage,
          leftPercentage = _ref.leftPercentage;

      // console.log(`--- this.setCenter(${this.width * leftPercentage / 100}, ${this.height * topPercentage / 100})`)
      if (!this.isStandPointIndicatorInViewport() && !this.isInteracting && !this.isAutoScrolling) {
        this.setCenter(this.width * leftPercentage / 100, this.height * topPercentage / 100);
      }
    },
    getPseudoCoords: function getPseudoCoords() {
      if (this.geoData && this.geoData.system === 'Pseudo') {
        var pseudoEngine = this.$xp.positioning.getEngine('Pseudo');
        return pseudoEngine.getLastPosition();
      }

      return null;
    },
    changeScale: function changeScale(dScale, center) {
      this.setScale(this.transform.scale + dScale, center);
    },
    setScale: function setScale(scale, center) {
      scale = Math.max(Math.min(scale, this.transform.maxScale), this.transform.minScale);

      if (center) {
        var boundingRect = this.mapElement.getBoundingClientRect();
        var cX = (center.x - boundingRect.left) / boundingRect.width * this.mapSize.width;
        var cY = (center.y - boundingRect.top) / boundingRect.height * this.mapSize.height;
        var dX = (this.mapSize.width / 2 - cX) * (scale - this.transform.scale);
        var dY = (this.mapSize.height / 2 - cY) * (scale - this.transform.scale);
      }

      var oldScale = this.transform.scale;
      this.transform.scale = scale;
      this.transform.maxX = -(this.mapSize.width * (1 - scale)) / 2 + Math.max(0, (this.wrapperSize.width - this.mapSize.width * scale) / 2);
      this.transform.maxY = -(this.mapSize.height * (1 - scale)) / 2 + Math.max(0, (this.wrapperSize.height - this.mapSize.height * scale) / 2);
      this.transform.minX = this.transform.maxX - Math.max(0, this.mapSize.width * scale - this.wrapperSize.width);
      this.transform.minY = this.transform.maxY - Math.max(0, this.mapSize.height * scale - this.wrapperSize.height);

      if (center) {
        this.changeTransform(dX, dY);
      }

      this.$emit('scaleChanged', this.transform.scale / this.scale100Percent * 100, oldScale / this.scale100Percent * 100);
    },
    changeTransform: function changeTransform(dX, dY) {
      this.setTransform(dX ? this.transform.x + dX : null, dY ? this.transform.y + dY : null);
    },
    setTransform: function setTransform(x, y) {
      if (x !== null) {
        this.transform.x = Math.max(Math.min(x, this.transform.maxX), this.transform.minX); // this.transform.x = x
      }

      if (y !== null) {
        this.transform.y = Math.max(Math.min(y, this.transform.maxY), this.transform.minY); // this.transform.y = y
      }
    },
    canPanX: function canPanX() {
      return this.transform.x < this.transform.maxX && Math.abs(this.transform.x - this.transform.maxX) >= 1 || this.transform.x > this.transform.minX && Math.abs(this.transform.x - this.transform.minX) >= 1;
    },
    canPanY: function canPanY() {
      return this.transform.y < this.transform.maxY && Math.abs(this.transform.y - this.transform.maxY) >= 1 || this.transform.y > this.transform.minY && Math.abs(this.transform.y - this.transform.minY) >= 1;
    },
    canPan: function canPan() {
      return this.canPanX() || this.canPanY();
    },
    onTouchStart: function onTouchStart(e) {
      this.showHints = false;
      if (this.isInteracting) return;
      this.isInteracting = true;
      this.hasMoved = false;
      this.lastTouchData = this.touchData = this.getTouchDataFromEvent(e);

      if (this.allowZoom) {
        this.checkForDoubleTap(e);
      }

      this.touchStartTime = new Date().getTime();
    },
    onTouchMove: function onTouchMove(e) {
      if (this.isInteracting === false) return;

      if (!this.$xp.screen.isBrowserNavBarVisible) {
        e.preventDefault();
      }

      this.touchData = this.getTouchDataFromEvent(e, this.lastTouchData);
      var dX = this.touchData.x - this.lastTouchData.x;
      var dY = this.touchData.y - this.lastTouchData.y;

      if (Math.abs(dX) >= 3 || Math.abs(dY) >= 3) {
        this.hasMoved = true;
      }

      this.changeTransform(dX, dY);

      if (this.allowZoom && this.touchData.pinchLength && this.lastTouchData.pinchLength) {
        var ratio = this.touchData.pinchLength / this.lastTouchData.pinchLength;
        var scale = this.transform.scale * ratio;
        this.setScale(scale, this.touchData);
      }

      this.lastTouchData = this.touchData;
    },
    onTouchEnd: function onTouchEnd(e) {
      var _this2 = this;

      this.isInteracting = false;
      var time = new Date().getTime();

      if (this.hasMoved || time - this.touchStartTime > 800) {
        e.stopPropagation(); // Workaround: stopPropagation() ist notwendig, um click-Events auf der Imagemap zu verhindern,
        // wenn der PageContainer das event nicht bekommt, werden aber die Navigationsleisten nicht wieder ausgeblendet
        // Deshalb wird das Event explizit an den .c-map gesendet.

        this.$el.dispatchEvent(new TouchEvent(e.type, e));
      } // console.log('touchData: ', this.lastTouchData)


      var vel = Math.sqrt(Math.pow(this.lastTouchData.vX, 2) + Math.pow(this.lastTouchData.vY, 2));

      if (vel > 10) {
        this.lastTouchData.autoTransformX = this.transform.x + 0.8 * this.lastTouchData.vX;
        this.lastTouchData.autoTransformY = this.transform.y + 0.8 * this.lastTouchData.vY;
        requestAnimationFrame(function () {
          _this2.autoScroll();
        });
      } else {
        this.$xp.history.setHistoryParam(this.pageId, 'transform', this.transform);
      }
    },
    checkForDoubleTap: function checkForDoubleTap(e) {
      if (this.$xp.device.platform !== 'browser') {
        if (e.touches.length === 1) {
          tapCounter++;
          singleClickTimer = setTimeout(function () {
            tapCounter = 0;
          }, 200);

          if (tapCounter === 2) {
            clearTimeout(singleClickTimer);
            tapCounter = 0;
            this.onDoubleTap(e);
          }
        }
      }
    },
    onDoubleTap: function onDoubleTap(e) {
      var touch = this.getTouchDataFromEvent(e);
      var scale = this.transform.scale * this.doubleTapZoomRatio;
      this.setScale(scale, touch);
    },
    autoScroll: function autoScroll() {
      var _this3 = this;

      if (this.lastTouchData.autoTransformX) {
        this.isAutoScrolling = true;
        var elapsed = Date.now() - this.lastTouchData.time;
        var exp = -0.8 * Math.exp(-elapsed / 325);
        var dX = this.lastTouchData.vX * exp;
        var dY = this.lastTouchData.vY * exp; // console.log('autoScroll() dX=', dX, 'dY=', dY, 'elapsed=', elapsed, 'exp=', exp)

        this.setTransform(this.lastTouchData.autoTransformX + dX, this.lastTouchData.autoTransformY + dY);

        if (Math.abs(dX) + Math.abs(dY) > 1) {
          requestAnimationFrame(function () {
            _this3.autoScroll();
          });
        } else {
          this.isAutoScrolling = false;
          this.lastTouchData.autoTransformX = null;
          this.$xp.history.setHistoryParam(this.pageId, 'transform', this.transform);
        }
      }
    },
    onMouseWheel: function onMouseWheel(e) {
      this.isInteracting = true;
      var touch = this.getTouchDataFromEvent(e); // console.log('onMouseWheel x=', touch.x)

      var ratio = e.deltaY > 0 ? 0.9 : 1.1;
      var scale = this.transform.scale * ratio;
      this.setScale(scale, touch);
      this.removeIsInteractingAfterWheel();
    },
    removeIsInteractingAfterWheel: function removeIsInteractingAfterWheel() {
      this.isInteracting = false;
    },
    setCenter: function () {
      var _setCenter = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(x, y) {
        var boundingRect, x1, y1, cX, cY;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log("setCenter(".concat(x, ", ").concat(y, ")"));
                boundingRect = this.mapElement.getBoundingClientRect();
                x1 = !x ? 0 : x / devicePixelRatio * (boundingRect.width / this.mapSize.width);
                y1 = !y ? 0 : y / devicePixelRatio * (boundingRect.height / this.mapSize.height);
                console.log("x1= ".concat(x1, ", y1= ").concat(y1), {
                  x1: x1,
                  y1: y1
                }); // let cX = (this.wrapperSize.width / 2) - x * boundingRect.width / (this.mapSize.width * devicePixelRatio) - boundingRect.left
                // let cY = (this.wrapperSize.height / 2) - y * boundingRect.height / (this.mapSize.height * devicePixelRatio) - boundingRect.top
                // console.log(`boundingRect `, { left: boundingRect.left, top: boundingRect.top, width: boundingRect.width, height: boundingRect.height })
                // console.log(`wrapperSize `, { width: this.wrapperSize.width, height: this.wrapperSize.height })

                cX = this.wrapperSize.width / 2 - boundingRect.left - x1;
                cY = this.wrapperSize.height / 2 - boundingRect.top - y1; // console.log('setCenter(', x, ', ', y, ') => cX=', cX, ', cY=', cY, ', boundingRect=', boundingRect, ', mapSize=', this.mapSize)
                // console.log({ x, y, cX, cY })

                this.changeTransform(cX, cY); // await this.$nextTick()
                // boundingRect = this.mapElement.getBoundingClientRect()
                // console.log(`boundingRect `, { left: boundingRect.left, top: boundingRect.top, width: boundingRect.width, height: boundingRect.height })
                // console.log({ transformX: this.transform.x, transformY: this.transform.y })

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function setCenter(_x, _x2) {
        return _setCenter.apply(this, arguments);
      }

      return setCenter;
    }(),
    getTouchDataFromEvent: function getTouchDataFromEvent(event, lastData) {
      var data = {
        x: 0,
        y: 0,
        vX: 0,
        vY: 0,
        pinchLength: null,
        time: Date.now()
      };

      if (event.type.match(/^(mouse|wheel)/)) {
        data.x = event.clientX;
        data.y = event.clientY;
      } else {
        if (event.touches.length === 1) {
          data.x = event.touches[0].clientX;
          data.y = event.touches[0].clientY;
        } else if (event.touches.length >= 2) {
          var finger1 = event.touches[0];
          var finger2 = event.touches[1];
          data.x = event.touches[0].clientX; // (finger1.clientX + finger2.clientX) / 2

          data.y = event.touches[0].clientY; // (finger1.clientY + finger2.clientY) / 2

          data.pinchLength = Math.sqrt(Math.pow(finger2.clientX - finger1.clientX, 2) + Math.pow(finger2.clientY - finger1.clientY, 2));
        }
      }

      if (lastData) {
        var d = data.time - lastData.time;
        var f = 300;
        var vX = f * (data.x - lastData.x) / (1 + d);
        var vY = f * (data.y - lastData.y) / (1 + d);
        data.vX = 0.8 * vX + 0.2 * lastData.vX;
        data.vY = 0.8 * vY + 0.2 * lastData.vY;

        if (data.pinchLength && lastData.pinchLength) {
          data.pinchLength = 0.8 * data.pinchLength + 0.2 * lastData.pinchLength;
        }
      }

      return data;
    },
    reInit: function reInit() {
      var _this4 = this;

      console.log('reInit panzoomMap');

      if (this.wrapperSize.width === 0) {
        // not initialized yet
        this.wrapperSize = this.mapElement.parentElement.getBoundingClientRect();

        if (this.wrapperSize.width > 0) {
          this.init();
        } else {
          setTimeout(function () {
            _this4.reInit();
          }, 200);
        }
      }
    },
    // showLocationPathCircle (center, radius) {
    //   this.locationPathAngle += 3
    //   let angle = this.locationPathAngle * Math.PI / 180
    //   let coords = {
    //     easting: center.easting + Math.cos(angle) * radius,
    //     northing: center.northing + Math.sin(angle) * radius,
    //     accuracy: 4
    //   }
    //   if (!isNaN(coords.easting) && !isNaN(coords.northing)) {
    //     this.showStandPoint(coords)
    //   }
    // },
    showLocationPathCorners: function showLocationPathCorners(corners) {
      this.locationPathAngle = (this.locationPathAngle + 1) % corners.length; // console.log('showLocationPathCorner(', this.locationPathAngle, '): ', corners[this.locationPathAngle])

      var corner = corners[this.locationPathAngle];
      this.showStandPoint(corner);
    }
  },
  watch: {
    '$xp.screen.orientation': {
      handler: function () {
        var _handler = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(v) {
          var _this5 = this;

          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return this.$nextTick();

                case 2:
                  setTimeout(function () {
                    _this5.wrapperSize = _this5.getWrapperSize();

                    _this5.init();
                  }, 1000);

                case 3:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, this);
        }));

        function handler(_x3) {
          return _handler.apply(this, arguments);
        }

        return handler;
      }()
    },
    '$xp.screen.isBrowserNavBarVisible': {
      handler: function () {
        var _handler2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(v) {
          var _this6 = this;

          return _regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  _context4.next = 2;
                  return this.$nextTick();

                case 2:
                  setTimeout(function () {
                    _this6.wrapperSize = _this6.getWrapperSize();

                    _this6.init();
                  }, 1000);

                case 3:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4, this);
        }));

        function handler(_x4) {
          return _handler2.apply(this, arguments);
        }

        return handler;
      }()
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "c-map" }, [
    _c(
      "div",
      {
        staticClass: "c-map__wrapper",
        on: {
          mousewheel: _vm.onMouseWheel,
          wheel: _vm.onMouseWheel,
          touchstart: function($event) {
            $event.preventDefault();
            return _vm.onTouchStart($event)
          },
          mousedown: function($event) {
            $event.preventDefault();
            return _vm.onTouchStart($event)
          },
          touchmove: _vm.onTouchMove,
          mousemove: _vm.onTouchMove,
          "!touchend": function($event) {
            $event.preventDefault();
            return _vm.onTouchEnd($event)
          },
          "!mouseup": function($event) {
            $event.preventDefault();
            return _vm.onTouchEnd($event)
          }
        }
      },
      [
        _c(
          "div",
          {
            class: {
              "js-map": true,
              "c-map__content": true,
              "c-map__content--smooth-transform":
                !_vm.isInteracting && !_vm.isAutoScrolling && _vm.isInitialized
            },
            style:
              "transform: " +
              _vm.transformMatrix +
              "; width: " +
              _vm.width / _vm.devicePixelRatio +
              "px; height: " +
              _vm.height / _vm.devicePixelRatio +
              "px"
          },
          [
            _vm._t("default"),
            _vm._v(" "),
            _c("span", { staticClass: "js-stand-point c-stand-point" }, [
              _c("span", {
                staticClass: "c-stand-point__blue-point",
                style:
                  "transform: translate(-50%, -50%) scale(" +
                  1 / _vm.transform.scale +
                  ")"
              })
            ])
          ],
          2
        ),
        _vm._v(" "),
        _vm.showHints && _vm.minZoom !== _vm.maxZoom
          ? _c("img", {
              class: {
                "c-map__zoom-hint": true,
                "c-map__hint": true,
                animated: _vm.isInitialized,
                fadeOut: _vm.isInitialized
              },
              attrs: {
                "aria-hidden": "true",
                src:
                  "data:image/svg+xml;base64,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"
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.showHints && _vm.minZoom === _vm.maxZoom && _vm.canPanX()
          ? _c("img", {
              class: {
                "c-map__pan-hint": true,
                "c-map__hint": true,
                animated: _vm.isInitialized,
                fadeOut: _vm.isInitialized
              },
              attrs: {
                "aria-hidden": "true",
                src:
                  "data:image/svg+xml;base64,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"
              }
            })
          : _vm._e()
      ]
    )
  ])
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = __vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
